var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97 5.309A3.75 3.75 0 018.657 2.25h6.446a3.75 3.75 0 013.638 2.84l.904 3.616a5.251 5.251 0 01.106 9.539V19.5a2.25 2.25 0 01-4.5 0v-.75h-6.5v.75a2.25 2.25 0 01-4.5 0v-1.255a5.25 5.25 0 01.082-9.528L4.97 5.31zm.97 2.97c.184-.019.37-.029.56-.029h11c.165 0 .328.008.49.023l-.705-2.819a2.25 2.25 0 00-2.183-1.704H8.656a2.25 2.25 0 00-2.211 1.835L5.94 8.28zm-.19 10.418v.803a.75.75 0 001.5 0v-.75H6.5c-.255 0-.505-.018-.75-.053zm11 .053v.75a.75.75 0 001.5 0v-.803a5.286 5.286 0 01-.75.053h-.75zm-10.25-9a3.75 3.75 0 100 7.5h11a3.75 3.75 0 100-7.5h-11z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5a1 1 0 11-2 0 1 1 0 012 0zm11 0a1 1 0 11-2 0 1 1 0 012 0z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/Parking.e0d4a5835d293d4571d3225ce7f58890.svg";
export { ForwardRef as ReactComponent };